export default [
  {
    stylers: [
      { hue: '#ff61a6' },
      { visibility: 'on' },
      { invert_lightness: true },
      { saturation: 40 },
      { lightness: 10 },
    ],
  },
];
